import { create } from "zustand";
import { persist } from "zustand/middleware";

// Cart is scoped to a single store: switching stores replaces items.
export const useCart = create(
  persist(
    (set, get) => ({
      storeId: null,
      items: [], // [{product_id, name, price, image_url, quantity}]
      add: (product, storeId) => {
        const state = get();
        let items = state.items;
        if (state.storeId && state.storeId !== storeId) {
          items = [];
        }
        const idx = items.findIndex((i) => i.product_id === product.product_id);
        if (idx >= 0) {
          items = items.map((it, i) =>
            i === idx ? { ...it, quantity: it.quantity + 1 } : it
          );
        } else {
          items = [
            ...items,
            {
              product_id: product.product_id,
              name: product.name,
              price: product.price,
              image_url: product.image_url,
              category: product.category,
              quantity: 1,
            },
          ];
        }
        set({ items, storeId });
      },
      inc: (productId) =>
        set((s) => ({
          items: s.items.map((it) =>
            it.product_id === productId ? { ...it, quantity: it.quantity + 1 } : it
          ),
        })),
      dec: (productId) =>
        set((s) => ({
          items: s.items
            .map((it) =>
              it.product_id === productId
                ? { ...it, quantity: it.quantity - 1 }
                : it
            )
            .filter((it) => it.quantity > 0),
        })),
      remove: (productId) =>
        set((s) => ({
          items: s.items.filter((it) => it.product_id !== productId),
        })),
      clear: () => set({ items: [], storeId: null }),
      subtotal: () =>
        get().items.reduce((sum, it) => sum + it.price * it.quantity, 0),
      count: () => get().items.reduce((n, it) => n + it.quantity, 0),
    }),
    { name: "greendrop-cart" }
  )
);
